import { defaultBaseClientUrl } from '~/constants/base-client-url'
import { singleton } from '~/decorators/dependency-container'

/**
 * Should be redacted from public.
 */
@singleton()
export default class InternalPageUrlService {
  getPageUrl(path: string): URL {
    let url: string = process.env.BASE_CLIENT_URL || defaultBaseClientUrl
    if (url.endsWith('/')) {
      url = url.substr(0, url.length - 1)
    }
    return new URL(url + path)
  }

  getReportSearchPageUrl(query: string): string {
    const params = new URLSearchParams()
    params.set('q', query)

    const url = this.getPageUrl('/admin/reports/search/')
    url.search = params.toString()
    return url.toString()
  }

  getBlacklistRemovalByIdentPageUrl(ident: string | number): string {
    const params = new URLSearchParams()
    params.set('ident', ident.toString())

    const url = this.getPageUrl('/admin/blacklist/remove_by_ident/')
    url.search = params.toString()
    return url.toString()
  }

  getClassifiedSearchPageUrl(
    category: string | number,
    ident: string | number
  ): string {
    const params = new URLSearchParams()
    params.set('category', category.toString())
    params.set('ident', ident.toString())

    const url = this.getPageUrl('/admin/classifieds/')
    url.search = params.toString()
    return url.toString()
  }

  getInteractionSearchPageUrl(event: string, query: string) {
    const params = new URLSearchParams()
    params.set('q', query)
    params.set('event', event)

    const url = this.getPageUrl('/admin/interactions/')
    url.search = params.toString()
    return url.toString()
  }
}
